<template>
    <b-modal
    ref="modal"
    id="agSettingModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    >
    <template #modal-header>
        <h4 class="agModal-title">Settings</h4>
    </template>
    <p>Default email server:</p>
    <b-dropdown :text="defaultEmailConnection.name">
        <b-dropdown-item
        v-for="conn in connections"
        @click="setEmailConnection(conn)"
        >{{ conn.name }}</b-dropdown-item>
    </b-dropdown>

    <template #modal-footer>
      <b-button class="agModal-buttonLeft" @click="hide">Cancel</b-button>
      <b-button class="agModal-buttonRight" variant="primary" @click="saveButton_Clicked">Save</b-button>
    </template>
    </b-modal>
</template>

<script>
import server from '../../server';

export default {
    name: "ag-setting-modal",
    data()
    {
        return {

        };
    },
    computed: {
        connections() {
            return this.$store.state.connStore.connections.filter((con) => con.type == "email");
        },
        defaultEmailConnection() {
            return this.$store.state.connStore.defaultEmailConnection;
        }
    },
    mounted() {
    },
    methods: {
        setEmailConnection(conn) {
            this.$store.state.connStore.defaultEmailConnection = conn;
        },
        show() {
          setTimeout(() => {
            this.$refs.modal.show();
          }, 250);
        },

        hide() {
          this.$refs.modal.hide();
        },

        async saveButton_Clicked() {
          var result = await server.post("/updateEmailConnection", {conn: this.defaultEmailConnection._id});
            //await server.post("", {conn: this.})
        },
    }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/user/SettingsModal.vue